/**
 * Client entry: the web Platform (first: module init reads storage), fonts + styles, then boot (see src/app/boot.ts).
 */
import './install-platform';
import '@fontsource/luckiest-guy';
import '@fontsource/bungee';
import '@fontsource/fredoka/latin-400.css';
import '@fontsource/fredoka/latin-600.css';
import '@fontsource/fredoka/latin-700.css';
import './styles.css';
import { boot } from './app/boot';

const stage = document.getElementById('stage');
const ui = document.getElementById('ui');
if (!stage || !ui) throw new Error('index.html is missing #stage or #ui');

boot({ stage, ui }).catch((err: unknown) => {
  console.error('[boot] failed', err);
  ui.textContent = 'Failed to start HAND EGG. See console.';
});
